// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"20d8a975","126":"b8ce1003","141":"75675712","334":"aa0d32da","361":"de712ddb","384":"b95ac481","749":"afba26b0","802":"e65bb4c1","813":"54351f8a"}[chunkId] + ".chunk.js";
};